// Browser Web Speech API helpers — STT & TTS
// Defensive: every function is always exported and never throws.

const noop = () => {};

export const supportsSTT = () => {
  try {
    return typeof window !== 'undefined' &&
      !!(window.SpeechRecognition || window.webkitSpeechRecognition);
  } catch (e) { return false; }
};

export const supportsTTS = () => {
  try {
    return typeof window !== 'undefined' && !!window.speechSynthesis;
  } catch (e) { return false; }
};

export const createRecognizer = (lang = 'en-IN') => {
  try {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) return null;
    const r = new SR();
    r.lang = lang;
    r.interimResults = false;
    r.maxAlternatives = 1;
    r.continuous = false;
    return r;
  } catch (e) { return null; }
};

let _voicesReady = false;
const ensureVoices = () => {
  try {
    if (!supportsTTS()) return;
    const v = window.speechSynthesis.getVoices();
    if (v && v.length) { _voicesReady = true; return; }
    window.speechSynthesis.onvoiceschanged = () => { _voicesReady = true; };
  } catch (e) {}
};
if (typeof window !== 'undefined') ensureVoices();

export const speak = (text, lang = 'en-IN', onEnd = noop) => {
  try {
    if (!supportsTTS() || !text) { onEnd(); return; }
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = lang;
    u.rate = 0.96;
    u.pitch = 1.03;
    const voices = window.speechSynthesis.getVoices() || [];
    const base = (lang || 'en').toLowerCase().split('-')[0];
    const exact = voices.find(v => v.lang && v.lang.toLowerCase() === lang.toLowerCase());
    const family = voices.find(v => v.lang && v.lang.toLowerCase().startsWith(base));
    const match = exact || family;
    if (match) u.voice = match;
    u.onend = () => { try { onEnd(); } catch (_) {} };
    u.onerror = () => { try { onEnd(); } catch (_) {} };
    window.speechSynthesis.speak(u);
  } catch (e) { try { onEnd(); } catch (_) {} }
};

export const stopSpeaking = () => {
  try {
    if (typeof window !== 'undefined' && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  } catch (e) {}
};

const _api = { supportsSTT, supportsTTS, createRecognizer, speak, stopSpeaking };
export default _api;